import React from 'react';
import TeamMaxHPSelector from '../Selector/TeamMaxHPSelector';
import DamageMultiplierSelector from '../Selector/DamageMultiplierSelector';
import { useTranslation } from '@/hooks/useTranslation';
import NumberOfTeamsSelector from '../Selector/NumberOfTeamsSelector';
import { GiPerspectiveDiceSixFacesOne } from 'react-icons/gi';
import TooltipFFXIV from '@/app/components/TooltipFFXIV';
import { useGame } from '@/app/providers/GameContextProvider';
import { useAudio, AUDIO } from '@/app/providers/AudioProvider';

interface TeamConfigProps {
    showNumberOfTeams?: boolean;
    showMaxHP?: boolean;
    showDamageMultiplier?: boolean;
}

const TeamConfig: React.FC<TeamConfigProps> = ({
    showNumberOfTeams = true,
    showMaxHP = true,
    showDamageMultiplier = true
}) => {
    const { t } = useTranslation();
    const { room, gameState } = useGame();
    const { play } = useAudio();

    const isGameMaster = room?.sessionId === gameState?.gameMasterId;
    const hasTeams = gameState?.teams && gameState.teams.length > 0;

    const handleRandomlyAssignTeams = () => {
        if (!room || !isGameMaster || !hasTeams) return;
        room.send('randomlyAssignTeams');
    };

    return (
        <div className="flex flex-col">
            <div className="flex gap-2">
                <div className="text-shadow-border shadow-black text-xl">{t('game.config.advancedSettings.teamConfig')}</div>
                {isGameMaster && hasTeams && (
                    <div 
                        className="relative w-7 h-7 flex items-center justify-center ffxiv-button rounded-full cursor-pointer text-2xl shadow shadow-black hover:bg-[#5B5B5B] active:bg-[#3B3B3B] transition-colors"
                        onMouseEnter={() => play(AUDIO.HOVER)}
                        onClick={() => {
                            play(AUDIO.CLICK);
                            handleRandomlyAssignTeams();
                        }}
                    >
                        <GiPerspectiveDiceSixFacesOne />
                        <TooltipFFXIV>
                            {t('game.config.advancedSettings.randomlyAssignTeams')}
                        </TooltipFFXIV>
                    </div>
                )}
            </div>
            <div className="flex flex-col gap-1 ml-3">
                {showNumberOfTeams && <NumberOfTeamsSelector />}
                {showMaxHP && <TeamMaxHPSelector />}
                {showDamageMultiplier && <DamageMultiplierSelector />}
            </div>
        </div>
    );
};

export default TeamConfig;
